<template>
  <!-- <form id="memoryItemForm" v-if="renderComponent"> -->
  <TabPanel>
    <app-input-status
      label="項目種別"
      :message="typeError"
      :validationError="typeError ? true : false"
      :success="type.length === 1 && !typeError ? true : false"
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('項目種別') + (Number(expenseId) + 1))
      "
    />
    <app-pull-down-list
      color="blue"
      placeholder="項目種別を選択してください"
      :items="memoryItemTypes ?? []"
      name="type"
      v-model="type"
      :showIcon="true"
    />

    <!-- <div
      class="flex flex-row justify-between mt-3"
      v-if="type.length && [3].includes(type[0].id)"
    >
      <div class="flex flex-col w-1/2">
        <app-input-status
          :label="getFromLabel(type[0].id)"
          class="mt-3"
          :message="fromError"
          :validationError="fromError ? true : false"
          :success="from && !fromError ? true : false"
        />
        <AppSentBackItem
            color="blue"
            :message="getSentBackItemMessage(getAttr('経路') + (Number(expenseId) + 1))"
          />
        <div class="flex flex-row items-center">
          <app-text-input
            color="blue"
            :placeholder="getFromLabel(type[0].id)"
            style="width: 160px"
            name="from"
            v-model="from"
          />
          <span v-if="type[0].id == 1" class="text-blue text-lg font-bold ml-1"
            >駅</span
          >
        </div>
      </div>
      <div class="flex items-center">
        <span
          class="text-lg font-bold text-blue"
          style="padding-top: 38px;padding-right: 4px;"
          >～</span
        >
      </div>
      <div class="flex flex-col w-1/2">
        <app-input-status
          :label="getToLabel(type[0].id)"
          class="mt-3"
          :message="toError"
          :validationError="toError ? true : false"
          :success="to && !toError ? true : false"
        />
        <AppSentBackItem
            color="blue"
            :message="getSentBackItemMessage(getAttr('経路') + (Number(expenseId) + 1))"
          />
        <div class="flex flex-row items-center">
          <app-text-input
            color="blue"
            :placeholder="getToLabel(type[0].id)"
            style="width: 160px"
            name="to"
            v-model="to"
          />
          <span v-if="type[0].id == 1" class="text-blue text-lg font-bold ml-1"
            >駅</span
          >
        </div>
      </div>
      <div
        class="flex items-center w-1/2"
        v-if="type.length && [3].includes(type[0].id)"
      >
        <div class="flex flex-row items-center" style="padding-top: 38px;">
          <app-checkbox
            explanation="往復"
            fieldId="1"
            color="blue"
            v-model="isRoundTrip"
            :rounded="true"
          />
          <span class="text-blue" v-show="isRoundTrip">
            {{ makeOneWayFareText(expenseAmount, numerator, denominator) }}
          </span>
        </div>
      </div>
    </div> -->

    <!-- <template v-if="type.length && [1, 2, 3].includes(type[0].id)">
      <app-input-status
        label="人数"
        class="mt-3"
        :message="peopleError"
        :validationError="peopleError ? true : false"
        :success="people && !peopleError ? true : false"
      />
      <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('人数') + (Number(expenseId) + 1))"
        />
        <AppSentBackItem
          color="blue"
          :message="
            getSentBackItemMessage(getAttr('宿泊人数/日数') + (Number(expenseId) + 1))
          "
        />
      <div class="flex flex-row items-center">
        <app-text-input-number
          v-model.number="people"
          color="blue"
          class="text-center"
          name="people"
          style="width: 64px"
        />
        <span class="text-blue text-lg font-bold ml-1">人</span>
      </div>
    </template> -->

    <!-- <template v-if="type.length && [2].includes(type[0].id)">
        <app-input-status
          label="距離"
          class="mt-3"
          :message="distanceError"
          :validationError="distanceError ? true : false"
          :success="distance && !distanceError ? true : false"
        />
        <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('距離') + (Number(expenseId) + 1))"
        />
        <div class="flex flex-row items-center">
          <app-text-input-number
            v-model.number="distance"
            color="blue"
            class="text-center"
            name="distance"
            style="width: 160px"
          />
          <span class="text-blue text-lg font-bold ml-1">Km</span>
          <div class="ml-3 flex flex-row items-center">
            <app-checkbox
              explanation="往復"
              fieldId="1"
              color="blue"
              v-model="isRoundTrip"
              :rounded="true"
            />
            <span class="text-blue" v-show="isRoundTrip">
              {{ makeOneWayDistanceText(distance) }}
            </span>
          </div>
        </div>
      </template> -->

    <template v-if="type.length && [1].includes(type[0].id)">
      <app-input-status
        label="宿泊数"
        class="mt-3"
        :message="stayDaysError"
        :validationError="stayDaysError ? true : false"
        :success="stayDays && !stayDaysError ? true : false"
      />
      <AppSentBackItem
        v-if="typeof expenseId === 'number'"
        color="blue"
        :message="
          getSentBackItemMessage(getAttr('宿泊数') + (Number(expenseId) + 1))
        "
      />
      <!--  <AppSentBackItem
          color="blue"
          :message="
            getSentBackItemMessage(getAttr('宿泊人数/日数') + (Number(expenseId) + 1))
          "
        /> -->
      <div class="flex flex-row items-center">
        <app-text-input-number
          v-model.number="stayDays"
          color="blue"
          class="text-center"
          name="stayDays"
          style="width: 64px"
        />
        <span class="text-blue text-lg font-bold ml-1">泊</span>
      </div>
    </template>
    <!-- 
    <template v-if="type.length && [1].includes(type[0].id)">
      <app-input-status
        label="一人当たりの料金"
        class="mt-3"
        :message="amountError"
        :validationError="amountError ? true : false"
        :success="amount && !amountError ? true : false"
      />
      <AppSentBackItem
          color="blue"
          :message="
            getSentBackItemMessage(getAttr('1人あたりの料金') + (Number(expenseId) + 1))
          "
        />
      <div class="flex flex-row items-center">
        <app-text-input-number
          v-model.number="amount"
          color="blue"
          class="text-right"
          name="amount"
          style="width: 160px"
        />
        <span class="text-blue text-lg font-bold ml-1">円</span>
      </div>
    </template> -->

    <!-- <template v-if="type.length && [4].includes(type[0].id)">
      <app-input-status
        label="研修内容"
        class="mt-3"
        :message="itemError"
        :validationError="itemError ? true : false"
        :success="item && !itemError ? true : false"
      />
      <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('研修内容') + (Number(expenseId) + 1))"
        />
      <app-text-input
        color="blue"
        placeholder="研修内容を入力してください"
        name="item"
        v-model="item"
      />
    </template> -->

    <!-- 
      <template v-if="type.length && [6].includes(type[0].id)">
        <app-input-status
          label="費目"
          class="mt-3"
          :message="itemError"
          :validationError="itemError ? true : false"
          :success="item && !itemError ? true : false"
        />
        <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('費目') + (Number(expenseId) + 1))"
        />
        <app-text-input
          color="blue"
          placeholder="費目を入力してください"
          name="item"
          v-model="item"
        />
      </template> -->

    <!-- <template v-if="type.length && [4].includes(type[0].id)">
        <app-input-status
          label="宿泊詳細"
          class="mt-3"
          :message="detailError"
          :validationError="detailError ? true : false"
          :success="detail && !detailError ? true : false"
        />
        <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('宿泊詳細') + (Number(expenseId) + 1))"
        />
        <app-text-input
          color="blue"
          placeholder="宿泊日、期間など入力ください"
          name="detail"
          v-model="detail"
        />
      </template> -->
    <!-- 
    <template v-if="type.length && [5].includes(type[0].id)">
      <app-input-status
        label="明細"
        class="mt-3"
        :message="detailError"
        :validationError="detailError ? true : false"
        :success="detail && !detailError ? true : false"
      />
      <AppSentBackItem
          color="blue"
          :message="getSentBackItemMessage(getAttr('明細') + (Number(expenseId) + 1))"
        />
      <app-text-input
        color="blue"
        placeholder="明細を入力してください"
        name="detail"
        v-model="detail"
      />
    </template> -->
  </TabPanel>
  <TabPanel>
    <app-input-status
      label="経費項目"
      :message="expenseTypeIdError"
      :validationError="expenseTypeIdError ? true : false"
      :success="expenseTypeId && !expenseTypeIdError ? true : false"
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('経費項目') + (Number(expenseId) + 1))
      "
    />
    <!-- <app-pull-down-list
      color="blue"
      placeholder="経費項目を選択してください"
      :items="expenseItems"
      name="expenseTypeId"
      v-model="expenseTypeId"
      :showIcon="false"
    /> -->
    <app-text-input
      :value="actionTypeNames(currentPoliticalAction['selectedActionTypes'])"
      name="expenseType"
      color="blue"
      style="padding-left: 20px"
      disabled
    />

    <app-input-status
      label="支出額"
      color="blue"
      :message="
        isPartial
          ? expenseAmountError || partialCommentError || partialAmountError
          : expenseAmountError || numeratorError
      "
      :validationError="
        expenseAmountError ||
        (isPartial && partialCommentError) ||
        (isPartial && partialAmountError) ||
        (isDistributed && numeratorError)
          ? true
          : false
      "
      :success="
        (!isPartial && expenseAmount && !expenseAmountError) ||
        (isPartial &&
          expenseAmount &&
          !expenseAmountError &&
          partialComment &&
          !partialCommentError &&
          partialAmount &&
          !partialAmountError) ||
        (isDistributed && numerator && denominator && !numeratorError)
          ? true
          : false
      "
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('支払額') + (Number(expenseId) + 1))
      "
    />
    <div class="flex items-center">
      <app-text-input
        class="mr-2 w-40 text-right"
        type="number"
        :block="false"
        color="blue"
        rows="1"
        placeholder="0"
        v-model.number="expenseAmount"
        name="expenseAmount"
      >
      </app-text-input>
    </div>
    <div class="flex items-center mt-2 mb-2">
      <app-checkbox
        ref="checkboxProrate"
        @click="checkboxAppropriationOff"
        class="mr-2"
        :fieldId="String(prorateType.id)"
        color="blue"
        :explanation="'按分'"
        :rounded="true"
        v-model="isDistributed"
        :modelValue="isDistributed"
        @change="isPartial = false"
      />
      <app-checkbox
        ref="checkboxAppropriation"
        @click="checkboxProrateOff"
        :fieldId="String(partialAmountType.id)"
        color="blue"
        :explanation="'一部充当'"
        :rounded="true"
        v-model="isPartial"
        :modelValue="isPartial"
        @change="isDistributed = false"
      />
    </div>

    <!-- 按分する場合 -->
    <div
      class="flex items-center border border-blue border-1 border-dotted w-full pl-2"
      style="border-radius:30px; height:60px;"
      v-if="isDistributed"
    >
      <span class="text-blue text-lg mr-2 ml-2 font-bold">
        按分率
      </span>
      <span class="w-16">
        <app-text-input
          type="number"
          v-model.number="numerator"
          name="numerator"
          placeholder="0"
          color="blue"
          class="text-center"
          style="padding: 1px"
        />
      </span>
      <span class="ml-3 text-blue">/</span>
      <span class="w-16 ml-3">
        <app-text-input
          type="number"
          v-model.number="denominator"
          name="denominator"
          placeholder="0"
          color="blue"
          class="text-center"
          style="padding: 1px"
        />
      </span>
      <span class="ml-3 text-blue">
        {{ calcPercent(numerator, denominator) }}%
      </span>
      <span class="ml-3 text-blue font-bold">=</span>
      <span class="ml-3 text-blue font-bold">
        {{ prorateAmount(expenseAmount, numerator, denominator) }}
      </span>
      <span class="ml-1 text-blue font-bold">円</span>
    </div>

    <!-- 充当する場合 -->
    <div
      class="inline-block items-center border border-blue border-1 border-dotted w-full pl-2"
      style="border-radius:30px; height:120px;"
      v-if="isPartial"
    >
      <div class="flex items-center mt-2 mb-1">
        <span class="flex text-blue text-lg mr-2 ml-2 font-bold">
          充当額
        </span>
        <span class="flex items-center w-16">
          <app-text-input
            class="w-40 text-right"
            type="number"
            :block="false"
            v-model.number="partialAmount"
            name="partialAmount"
            placeholder="0"
            color="blue"
            style="padding: 10px"
          /><span class="ml-3 text-blue"> 円 </span>
        </span>
      </div>
      <div class="flex items-center">
        <span
          class="text-blue text-lg mr-6 ml-2 font-bold"
          style="white-space: nowrap;"
        >
          内容
        </span>
        <textarea
          class="border border-blue border-1 w-full resize-none mr-2 ml-1"
          style="border-radius:20px; padding: 5px; white-space: pre-wrap;"
          v-model="partialComment"
          placeholder="一部充当内容を入力してください"
          name="partialComment"
          color="blue"
          rows="2"
        />
      </div>
    </div>

    <app-input-status
      label="支出日"
      class="mt-3"
      :message="expenseDateError"
      :validationError="expenseDateError ? true : false"
      :success="expenseDate && !expenseDateError ? true : false"
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('支払年月日') + (Number(expenseId) + 1))
      "
    />
    <app-date-input
      placeholder="支出日"
      v-model="expenseDate"
      name="expenseDate"
      color="blue"
    />

    <div class="flex">
      <app-input-status
        label="支出内容"
        class="mt-3"
        :message="expenseContent1Error"
        :validationError="expenseContent1Error ? true : false"
        :success="expenseContent1 && !expenseContent1Error ? true : false"
      />
      <span class="mt-3 ml-3 text-lg text-blue" style="height: 28px;">
        | 1行目に入力してください
      </span>
      <app-checkbox
        class="mt-3.5 ml-4"
        :fieldId="String(haveReceiptImagesType.id)"
        color="blue"
        :explanation="'支払い証明書'"
        :rounded="true"
        v-model="haveReceiptImages"
        :modelValue="haveReceiptImages"
      />
    </div>
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('支出内容') + (Number(expenseId) + 1))
      "
    />
    <div
      class="border bg-white border-blue w-full h-auto flex flex-col px-2 py-2"
      style="border-radius: 20px;"
    >
      <textarea
        :placeholder="haveReceiptImages ? '内訳' : '支出内容を入力してください'"
        color="blue"
        v-model="expenseContent1"
        name="expenseContent1"
        class="w-full mb-2 focus:outline-none resize-none"
        style="overflow: hidden; height: 48px;"
      />
      <div style="border: 1px dashed #2993CE;" />
      <textarea
        :placeholder="
          haveReceiptImages ? '理由' : '補記が必要な場合に入力してください'
        "
        color="blue"
        maxlength="100"
        v-model="expenseContent2"
        name="expenseContent2"
        class="w-full mt-2 focus:outline-none resize-none"
        style="background: rgba(0, 0, 0, 0);"
        :style="haveReceiptImages ? 'height:52px;' : 'height:24px;'"
      />
      <div v-if="haveReceiptImages" style="border: 1px dashed #2993CE;" />
      <textarea
        v-if="haveReceiptImages"
        placeholder="債権者住所・氏名"
        color="blue"
        rows="1"
        maxlength="100"
        class="w-full mt-1 focus:outline-none resize-none"
        style="height:48px; background: rgba(0, 0, 0, 0);"
        v-model="creditorInfo"
        name="creditorInfo"
      />
    </div>

    <!-- 差し戻しコメント用補記(理由) -->
    <app-input-status
      v-if="
        getSentBackItemMessage('expense_addendum' + (Number(expenseId) + 1))
          .length !== 0 && typeof expenseId === 'number'
      "
      :label="haveReceiptImages ? '理由' : '補記'"
      color="blue"
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage('expense_addendum' + (Number(expenseId) + 1))
      "
    />
    <!-- 差し戻しコメント用債権者住所 -->
    <app-input-status
      v-if="
        getSentBackItemMessage('creditor_info' + (Number(expenseId) + 1))
          .length !== 0 && typeof expenseId === 'number'
      "
      label="債権者住所・氏名"
      color="blue"
    />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage('creditor_info' + (Number(expenseId) + 1))
      "
    />
  </TabPanel>
  <TabPanel>
    <app-input-status label="領収書" />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage(getAttr('領収書') + (Number(expenseId) + 1))
      "
    />
    <AppImageUploader
      @changed="handleImages"
      type="memory"
      color="blue"
      colorCode="#2993CE"
    />
  </TabPanel>
  <TabPanel>
    <!-- 資料【旅程表など】［任意］ -->
    <app-input-status label="資料【旅程表など】［任意］" />
    <AppSentBackItem
      v-if="typeof expenseId === 'number'"
      color="blue"
      :message="
        getSentBackItemMessage('additional_resources' + (Number(expenseId) + 1))
      "
    />
    <AppFileUploader type="memory" color="blue" colorCode="#2993CE" />
    <!-- 資料【旅程表など】［任意］ -->
  </TabPanel>
  <!-- </form> -->
  <button
    id="memory-validate-toda"
    style="display: none;"
    @click="memorySubmit()"
  ></button>
</template>

<script>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import AppPullDownList from '@/components/ui/AppPullDownList.vue'
import { TabPanel } from '@headlessui/vue'
import AppDateInput from '@/components/ui/AppDateInput'
import AppSentBackItem from '@/components/ui/AppSentBackItem'
import AppTextInput from '@/components/ui/AppTextInput'
import AppTextInputNumber from '@/components/ui/AppTextInputNumber'
import AppInputStatus from '@/components/ui/AppInputStatus'
import AppCheckbox from '@/components/ui/AppCheckbox.vue'
import AppImageUploader from '@/components/ui/uiToda/AppImageUploaderToda'
import AppFileUploader from '@/components/ui/uiToda/AppFileUploader.vue'
import { useMemoryForm } from '@/services/politicalActionToda/useMemoryForm'
import { useMemoryItems } from '@/services/politicalActionToda/useMemoryItems'
import { useMemoryItemForm } from '@/services/politicalActionToda/useMemoryItemForm'
import { useMemoryItemFormTabs } from '@/services/politicalActionToda/useMemoryItemForm'
import { expenseItems } from '@/const.js'
import { useImgUploader } from '@/services/useImgUploader'
import { useFileUploader } from '@/services/useFileUploader'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'

export default {
  name: 'MemoryItemForm_TODA',

  components: {
    TabPanel,
    AppPullDownList,
    AppTextInput,
    AppTextInputNumber,
    AppInputStatus,
    AppCheckbox,
    AppDateInput,
    AppImageUploader,
    AppFileUploader,
    AppSentBackItem,
  },

  setup() {
    // プロパティ
    const { memoryItemTypes } = useMemoryItems()
    const {
      updateImages,
      images,
      additionalResources,
      currentMemoryItems,
    } = useMemoryItemForm()
    const { tabs } = useMemoryItemFormTabs()
    const { imgUploader } = useImgUploader()
    const { fileUploader } = useFileUploader()
    const { currentPoliticalAction, actionTypeNames } = usePoliticalActions()
    const { expenseId } = useMemoryItemForm()
    const checkboxProrate = ref('')
    const checkboxAppropriation = ref('')

    const checkboxProrateOff = () => {
      checkboxProrate.value.isChecked = false
    }
    const checkboxAppropriationOff = () => {
      checkboxAppropriation.value.isChecked = false
    }
    const prorateType = { id: 0, largeName: '按分', name: 'isDistributed' }
    const partialAmountType = { id: 1, largeName: '一部充当' }
    const haveReceiptImagesType = { id: 2, largeName: '支払い証明書' }
    // ライフサイクル
    onBeforeUnmount(() => {
      // とじまい
      const { initMemoryItemForm } = useMemoryItemForm()
      initMemoryItemForm()
    })

    onMounted(() => {
      const imagesList = []
      const expenseImages = images.value

      if (expenseImages.length == 1 && !expenseImages[0].normalImage) {
        imagesList.length = 0
      } else {
        expenseImages.forEach(image =>
          imagesList.push(
            image.blackImage != null ? image.blackImage : image.normalImage,
          ),
        )
      }

      imgUploader.error = ''
      imgUploader.files = []
      imgUploader.dropped = 0
      imgUploader.imgs = imagesList

      let expenseAdditionalResources = []
      if (additionalResources.value.length == 0) {
        expenseAdditionalResources = []
      } else {
        for (let i = 0; i < additionalResources.value.length; i++) {
          expenseAdditionalResources.push(additionalResources.value[i])
        }
      }
      fileUploader.error = ''
      fileUploader.files = expenseAdditionalResources
      fileUploader.dropped = 0

      // haveReceiptImagesがtrueの時に領収書添付のタブをdisablesdにする
      tabs[2].disabled = currentMemoryItems.haveReceiptImages
    })

    /**
     * 按分計算し、カンマ区切りをつけた文字列を返す
     *
     * @param {number} amount 支出額
     * @param {number} numerator 分子
     * @param {number} denominator 分母
     * @return {string}
     */
    const prorateAmount = (amount, numerator, denominator) => {
      if (
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator === 0 ||
        denominator === 0
      ) {
        // invalid
        return ''
      }

      return Math.floor((numerator * amount) / denominator).toLocaleString()
    }

    /**
     * パーセントを計算する
     *
     * @param {number} numerator 分子
     * @param {number} denominator 分母
     * @return {string}
     */
    const calcPercent = (numerator, denominator) => {
      if (
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator === 0 ||
        denominator === 0
      ) {
        // invalid
        return ''
      }

      const percent = Math.floor((numerator * 10000) / denominator) / 100
      return percent.toString()
    }

    /**
     * 片道料金表示用文字列を作成する\
     * 経費を按分計算したものを割った数、小数点以下は切り捨て
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     */
    const makeOneWayFareText = (amount, numerator, denominator) => {
      if (!amount) {
        return ''
      }

      let halfAmount = 0
      if (
        typeof numerator !== 'number' ||
        typeof denominator !== 'number' ||
        numerator === 0 ||
        denominator === 0
      ) {
        halfAmount = Math.floor(amount / 2)
      } else {
        halfAmount = Math.floor(((numerator / denominator) * amount) / 2)
      }
      return `| 片道 ${halfAmount}円`
    }

    /**
     * 表示用片道距離文字列を作成する
     *
     * @param {number} distance
     */
    const makeOneWayDistanceText = distance => {
      if (!distance) {
        return ''
      }
      const halfDistance = distance / 2
      return `| 片道 ${halfDistance}Km`
    }

    const expenseTitleToAttrMap = new Map([
      ['項目種別', 'type'],
      ['経路', 'transportation'],
      ['人数', 'people'],
      ['距離', 'distance'],
      ['宿泊人数/日数', 'people/days'],
      ['1人あたりの料金', 'price'],
      ['明細', 'detail'],
      ['研修内容', 'item'],
      ['宿泊詳細', 'accommodation_details'],
      ['経費項目', 'expense_type'],
      ['支払額', 'expense_amount'],
      ['支払年月日', 'expense_date'],
      ['支出内容', 'expense_content'],
      ['領収書', 'file'],
    ])

    const getAttr = title => {
      return expenseTitleToAttrMap.get(title)
    }

    return {
      memoryItemTypes,
      expenseItems,
      makeOneWayFareText,
      makeOneWayDistanceText,
      prorateAmount,
      calcPercent,
      updateImages,
      expenseId,
      getAttr,
      currentPoliticalAction,
      actionTypeNames,
      prorateType,
      partialAmountType,
      checkboxProrate,
      checkboxAppropriation,
      checkboxProrateOff,
      checkboxAppropriationOff,
      haveReceiptImagesType,
      tabs,
      currentMemoryItems,
      ...useMemoryForm(),
      ...useMemoryItemForm(),
    }
  },
}
</script>
<style lang=""></style>
